<script>
  import Terms from "./v0.0.0.svelte";
</script>

<div class="terms">
  <Terms />
</div>

<style>
  .terms {
    background-color: #eee;
    border-radius: 10px;
    --color: var(--secondary);
    max-height: 200px;
    overflow: auto;
    margin: 1rem auto;
    padding: 1rem 2rem;
  }
  :global(.terms > *) {
    font-size: 0.8em;
    margin: auto;
    border-color: red !important;
  }
</style>
